import { baseUrl } from "./config"
export function fimg(id) {
    let url
    if (id.indexOf('http') == -1) {
        url = baseUrl + '/sysFileInfo/preview?id=' + id
    }
    url = id
    return url
}